var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "memory-card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3,6,38,13.7V42H10V6H30.3M32,2H8A2,2,0,0,0,6,4V44a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V12L32,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,18a2,2,0,0,1-2-2V12a2,2,0,0,1,4,0v4A2,2,0,0,1,16,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,18a2,2,0,0,1-2-2V12a2,2,0,0,1,4,0v4A2,2,0,0,1,22,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,18a2,2,0,0,1-2-2V12a2,2,0,0,1,4,0v4A2,2,0,0,1,28,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,30H16a2,2,0,0,1,0-4H32a2,2,0,0,1,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,38H16a2,2,0,0,1,0-4H32a2,2,0,0,1,0,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisk);
export default __webpack_public_path__ + "static/media/disk.50dddf2891895e733c2012cda9926e4c.svg";
export { ForwardRef as ReactComponent };